$shm_hitalama_map_widget_float_ai_request_html_changes $shm_hitalama_map_widget_float_ai_request_html
